import React from 'react';
import AddPackagePaymentSettingComponent from '../../../Components/PackagePaymentSetting/AddPackagePaymentSetting';

export default function AddPackagePaymentSetting() {
    return (
        <div className='page-body'>
            <AddPackagePaymentSettingComponent />
        </div>
    );
}